exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TinkoffPayForm{display:block;text-align:center;margin-bottom:2rem}.TinkoffPayForm input[type=submit]{display:inline-block;width:200px;border-radius:2px;border:1px solid #1d9c56;text-align:center;padding:1rem;text-decoration:none;background:#1d9c56;color:#fff;font-size:1.125rem;cursor:pointer}", ""]);

// exports
